<app-header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="page-content-wider">

    <div *ngIf="canGoBack" class="back-container"><span class="back-btn" (click)="back()">< {{getString('back')}}</span></div>

    <div class="details-container">

        <div class="page-top">

            <h1 class="page-title">{{formatString(getString('moviesFromStudioX'), studios)}}</h1>
            <span class="page-subtitle">{{getString('availableOn')}}
                <span *ngIf="getStore() == 'itunes'"><img class="store-brand-icon" src="./assets/images/store-icons/apple-tv.png"> Apple TV</span>
                <span *ngIf="getStore() == 'amazon'"><img src="./assets/images/amazon.png"> Amazon</span>
                <span *ngIf="getStore() == 'googlePlay'"><img src="./assets/images/googlePlay.png">Google Play</span>
                <span *ngIf="getStore() == 'vudu'"><img src="./assets/images/vudu.png"></span>
            </span>

        </div>

        <div class="filter-toggle-btn" (click)="filtersShown=!filtersShown">
            <img src="./assets/images/filter_icon_blue.png">
            <span *ngIf="!filtersShown">{{getString('showFilters')}}</span>
            <span *ngIf="filtersShown">{{getString('hideFilters')}}</span>
        </div>

        <div *ngIf="filtersShown" class="filters-container-test">

            <div class="normal-filters">
                <div class="filters-panel">
                    <div class="filter-test">
                        <app-multichoice-menu class="dd-test" [alignLeft]="true" [title]="getString('genres')" [label]="getString('genres')" [itemList]="genres" [selectedItemsList]="selectedGenres" (selectionChanged)="genreChanged($event)"></app-multichoice-menu>
                    </div>
                    <div class="filter-test">
                        <app-dropdown class="dd-test" [alignLeft]="true" [label]="getString('offers')" [items]="offersFilterOptions" [selectedItem]="selectedOffersFilterOption" [default]="offersFilterOptions[0]" [stringAttr]="'title'" [stringAttrIntl]="true" [right]="true" (onItemSelected)="offersFilterChanged($event)"></app-dropdown>
                    </div>
                    <div class="filter-test" *ngIf="listType != 'pricefilter' && listType != 'nowfree'">
                        <app-slider-multichoice class="dd-test" [alignLeft]="true" [title]="getString('priceFilter')" [isPrice]="true" [label]="getString('priceFilter')" [itemList]="priceRanges" [selectedItemsList]="selectedPriceRanges" (selectionChanged)="priceRangeChanged($event)"></app-slider-multichoice>
                    </div>
                    <div class="filter-test" *ngIf="selectedMediaType == 'movies' && listType != 'bundles'">
                        <app-filter-dropdown #movieRatingsDD class="dd-test" [alignLeft]="true" [title]="getString('movieRatings')" [label]="getString('movieRatings')" [redText]="getActiveMovieRatingsFilters() != getString('none')" [selection]="movieRatingsSelection" (onReset)="resetMovieRatingsFilters()" (onOpen)="movieRatingsSliders.init()">
                        <app-movie-ratings-sliders #movieRatingsSliders [movieRatingsFilters]="movieRatingsFilters" (onApply)="movieRatingsDD.closeDropdown();applyMovieRatingsFilter($event)"></app-movie-ratings-sliders>
                        </app-filter-dropdown>
                    </div>
                    <div class="filter-test">
                        <app-slider-year class="dd-test" [alignLeft]="true" [title]="getString('year2')"
                        [label]="getString('year2')"
                        [selectedItemsList]="selectedReleaseYear"
                        [constMinValue]="1900"
                        [constMaxValue]="currentYear"
                        (selectionChanged)="releaseYearChanged($event)"></app-slider-year>
                    </div>
                    <div class="filter-test" *ngIf="shouldShowRuntimeFilter()">
                        <app-slider-runtime class="dd-test" [alignLeft]="true" [title]="getString('runtime')"
                        [label]="getString('runtime')"
                        [selectedItemsList]="selectedRuntime"
                        [constMinValue]="1"
                        [constMaxValue]="350"
                        (selectionChanged)="runtimeChanged($event)"></app-slider-runtime>
                    </div>
                    <div class="filter-test" *ngIf="shouldShowFrenchTitlesFilter()">
                        <app-dropdown class="dd-test" [alignLeft]="true" [label]="getString('frenchTitles')" [items]="getFrenchTitlesOptions()" [selectedItem]="selectedFrenchTitlesOption" [default]="getFrenchTitlesOptions()[0]" [stringAttr]="'title'" [stringAttrIntl]="true" [right]="true" (onItemSelected)="frenchTitlesChanged($event)"></app-dropdown>
                    </div>
                </div>
                <div class="studios-sort-row">
                    <div class="filter-test">
                        <app-dropdown class="dd-test" [alignLeft]="true" [label]="getString('sortBy')" [items]="sortValues" [selectedItem]="sortKey" [right]="true" (onItemSelected)="sortChanged(listType, $event)"></app-dropdown>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!isLoading && (!items || items.length == 0)" class="message-div">
            {{getString('noMatchFound')}}
        </div>

        <div class="items-container">

            <div class="item-container" *ngFor="let item of items; let i = index;">
            <ng-container *ngIf="!hideBecausePurchased(item)">
                <app-date-separator [mode]="getDateSeparatorMode()" [shouldDisplay]="showDateSeparator(item, i)"
                [date]="getDate(item)"></app-date-separator>
                <app-grid-item [item]="item" [priceHint]="'offerslist'"
                (onItemClicked)="itemClicked($event, item)"
                (onWishlistClicked)="addToWishlist(item)"
                (onOwnlistClicked)="addToOwnlist(item)"
                (onBlocklistClicked)="addToBlocklist(item)"></app-grid-item>
            </ng-container>
            </div>

        </div>

    </div>

    <div *ngIf="showSpinner" class="spinner-container txt-algn-cntr">
        <app-spinner></app-spinner>
    </div>

</div>
